import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import PubSub, { topics } from '../../lib/pubsub';

import Top from '../navigation/top';

import Images from '../form/images';
import { FormRow } from '../form/formField';
import TagTree from './tree';

import util from '../../lib/util';

const initialState = {
    height: 100,
    windowHeight: 0,
};

const FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    author: { label: 'Author', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    sort: { label: 'Sort', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    status: { label: 'Status', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    tag: { label: 'Tag', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    title: { label: 'Title', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    url: { label: 'URL', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    urlTarget: { label: 'Open in new window', type: 'checkbox', readonly: false, help: 'Field is DealerWeb only.' },
    ingress: { label: 'Ingress', type: 'textarea', rows: 5, readonly: false, help: 'Field is DealerWeb only.' },
    body: { label: 'Body', type: 'textarea', rows: 15, readonly: false, help: 'Field is DealerWeb only.' },
    productsearch: { label: 'productsearch', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    introYear: { label: 'introYear', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    imgs: { label: 'Image preview', type: 'imageList', imagePrefix: 'article', readonly: false, help: 'Field is DealerWeb only.' },
    images: { label: 'Images', type: 'json', readonly: false, help: 'Field is DealerWeb only.' },
    version: { label: 'Document version', type: 'text', readonly: false, help: 'Field is DealerWeb only. Value should be 1, 2, 3, etc.' },
    publishDate: { label: 'Publish date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updated: { label: 'Updated date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    create_date: { label: 'Created date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
};

@observer
class ArticleEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
            previewServer: util.getPreviewServer(),
            jwtToken: util.getJwtToken(),
        };
        this.updateTimer = {};
        const { articleStore } = this.props.stores;
        articleStore.load(props.id);
        this.fields = [
            {
                tabname: 'Basics',
                icon: 'fas fa-user-edit',
                fields: ['id', 'author', 'sort', 'status', 'version', 'tag', 'tags', 'title',
                    'url', 'urlTarget', 'ingress', 'body', 'productsearch', 'introYear', 'imgs', 'images', 'updated', 'create_date'].map(f => util.makeField(f, FIELDS)),
            },
            {
                tabname: 'Images',
                icon: 'fas fa-image',
                fields: [
                    {
                        name: 'imgs',
                        label: 'Images',
                        type: 'object',
                        view: (val, opt) => {
                            const opts = {
                                id: opt.id,
                                name: opt.name,
                                value: val,
                                imagePrefix: 'article',
                                updateField: opt.updateField,
                                handleAddImage: (imageObject) => {
                                    const options = opt;
                                    this.addArticleImage(options.id, imageObject);
                                },
                                handleDelImage: (imageId) => {
                                    const options = opt;
                                    this.delArticleImage(options.id, imageId);
                                },
                            };
                            return <Images {...opts} />;
                        },
                        readonly: false,
                        help: 'Field is DealerWeb only.',
                    },
                ],
            },
        ];
        this.subscriptions();
    }

    subscriptions() {
        PubSub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, (height) => {
            this.setState({ height });
        });
    }

    // {
    //     "2":{
    //         "id":3191,
    //         "title":"Get Busy Tying - Loon Fly Tying Tools",
    //         "ingress":"With so many fly fishermen in lockdown across Europe it's time to get busy tying flies - time to prepare for better times... Check out the Loon fly tying tool assortment with plenty of news for 2020.",
    //         "create_date":"2020-04-14T07:04:50.144Z",
    //         "updated":"2020-04-14T09:12:28+02:00",
    //         "tag":10,
    //         "tags":[{"id":10,"name":"news"}],
    //         "status":2,
    //         "author":"rasmus@flyfisheurope.com",
    //         "imgs":{
    //             "1":{
    //                 "name":"Fly Tying Tools1.jpg",
    //                 "encoding":"7bit",
    //                 "mimetype":"image/jpeg",
    //                 "ext":".jpg",
    //                 "newFilename":"dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg",
    //                 "s3Link":"https://dealer.flyfisheurope.com/originaldealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg",
    //                 "s3ThumbLink":"https://dealer.flyfisheurope.com/80x80/dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg"
    //             }
    //         },
    //         "url":"https://dealer.flyfisheurope.com/html/dealerweb-v2.html#/product/loon/Fly%20Tying%20Tools",
    //         "images":{
    //             "tiny":"80x80/dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg",
    //             "small":"220x/dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg",
    //             "medium":"400x/dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg",
    //             "large":"1024x/dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg",
    //             "xlarge":"1280x/dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg",
    //             "xxlarge":"1600x/dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg"
    //         }
    //     }
    // }

    updateField = async (id, field, value) => {
        const { articleStore } = this.props.stores;
        articleStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { articleStore } = this.props.stores;
        await articleStore.saveField(id, field, value);
    }

    addArticleImage = async (id, imageObject) => {
        const { articleStore } = this.props.stores;
        articleStore.addImage(id, imageObject);
    }

    delArticleImage = async (id, imageId) => {
        const { articleStore } = this.props.stores;
        articleStore.delImage(id, imageId);
    }

    render(props) {
        const { height, previewServer, jwtToken } = this.state;
        const { articleStore } = this.props.stores;
        const { article, saved } = articleStore;

        let tabIdx = this.fields.findIndex(e => e.tabname === props.tabname);
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return (
            <div>
                <Top {...props} />

                <div class='row'>
                    <div class='col-2 fixed-top overflow-auto'
                        style={`margin-top: ${height + 60}px; height: calc(100% - ${height + 60}px);`}
                    >
                        <small>
                            <TagTree {...this.props} />
                        </small>
                        <div class='text-center mt-4 mb-2'>
                            <small class='text-muted'>
                                <i class='fas fa-ellipsis-h' />
                            </small>
                        </div>
                    </div>
                    <div class='col-10 offset-2'>
                        <div class='d-flex flex-row bd-highlight mb-3'>
                            <div>
                                <a href='/articles' class={`mr-2 btn btn-sm btn-warning`}>
                                    <i class={`fas fa-arrow-left mr-1`} />
                                    Back
                                </a>
                            </div>
                            <div class='flex-grow-1'>
                                <h4>Edit: {article.id}: {article.title}</h4>
                            </div>
                            <div>
                                <a href={`${previewServer}/flyfisheurope/${article.tag}/${article.id}?token=${jwtToken}`}
                                    target='_blank'
                                    class={`mr-2 btn btn-sm btn-primary float-right`}>
                                    Preview
                                    <i class='fas fa-share ml-2' />
                                </a>
                            </div>
                        </div>
                        <ul class='nav nav-tabs mb-2'>
                            {this.fields.map(tab => (
                                <li class='nav-item'>
                                    <a class={`nav-link ${props.tabname === tab.tabname ? 'active' : ''}`}
                                        href={`/articles/${props.id}/${tab.tabname}`}
                                    >
                                        <i class={`${tab.icon} mr-2`} />
                                        {tab.tabname}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {this.fields[tabIdx].fields.map(field => <FormRow
                            field={field}
                            object={article}
                            saved={saved}
                            updateField={this.updateField}
                        />)}


                    </div>
                </div>
            </div>
        );
    }
}

export default ArticleEdit;



// WEBPACK FOOTER //
// ./components/articles/edit.js